<template>
  <b-container class="search-list" fluid="lg">
    <b-row>
      <b-col class="search-box">
        <div class="w-100">
          <div class="mb-3">
            <h3 class="mb-2 common__search-title">Tutor</h3>
            <SearchTutor v-model="conditions.tutor"/>
          </div>
          <div>
            <h3 class="mb-2 common__search-title">Item Type</h3>
            <ScheduleTypesInput v-model="conditions.types"/>
          </div>
        </div>
      </b-col>
      <b-col class="search-box">
        <div class="w-100">
          <div class="mb-3">
            <h3 class="mb-2 common__search-title">University</h3>
            <University v-model="conditions.university"/>
          </div>
          <div class="mb-3" v-show="conditions.university && conditions.university.code === '01'">
            <h3 class="mb-2 common__search-title">Campus</h3>
            <CampusesInput
              v-model="conditions.campuses"
              :belongsToUniversity="conditions.university"
            />
          </div>
          <div class="mb-3">
            <h3 class="mb-2 common__search-title">Subject</h3>
            <SelectSubjectInput v-model="conditions.subject"/>
          </div>
          <div class="mb-3">
            <h3 class="mb-2 common__search-title">Level</h3>
            <LevelsInput v-model="conditions.levels" />
          </div>
        </div>
      </b-col>
      <b-col>
        <StatusCard/>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="changeConditions"
      >
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import CampusesInput from '@/components/parts/inputItem/CampusesInput.vue';
import ScheduleTypesInput from '@/components/parts/inputItem/ScheduleTypesInput.vue';
import StatusCard from '@/components/parts/StatusCard.vue';
import SearchTutor from '@/components/parts/inputItem/SearchTutor.vue';
import SelectSubjectInput from '@/components/parts/inputItem/SelectSubjectInput.vue';
import LevelsInput from '@/components/parts/inputItem/LevelsInput.vue';
import University from '@/components/parts/inputItem/SelectUniversityInput.vue';
import _ from 'lodash'
import { ClockInSearchConditions } from '@/store/clockIn/types'

const initialConditions: ClockInSearchConditions = {
  university: null,
  types: [],
  tutor: null,
  campuses: [],
  subject: null,
  levels: [],
}

@Component({
  components: {
    University,
    CampusesInput,
    ScheduleTypesInput,
    StatusCard,
    SearchTutor,
    SelectSubjectInput,
    LevelsInput,
  },
})
export default class ClockinSearch extends Vue {
  private conditions: ClockInSearchConditions = _.cloneDeep(initialConditions)

  private changeConditions() {
    this.$emit('changedConditions', this.conditions)
  }

  reset() {
    this.conditions = _.cloneDeep(initialConditions)
    this.$emit('changedConditions', this.conditions);
  }
}
</script>

<style scoped>
.search-list {
  background: #D8D8D8;
  padding-top:20px;
  padding-bottom: 20px;
  position: relative;
}

.search-box {
  display:flex;
  width:60%;
  justify-content: space-between;
  margin-bottom:20px;
}

input[type="text"], select{
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 100%;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

</style>
